import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Col } from "react-awesome-styled-grid";
import { FlexContainer, H1Text, Hr, Text } from "../../design";
import React, { useState } from "react";
import ApplePayLogo from "../icons/ApplePay"


type Props = {
  tabs: Array,
  tabPanels: Array,
  onSelect: Function,
  defaultSelectedTab: number,
  name: string,
  mode: String,
  paymentTypes: string,
  tabName: string,
  upiDown: Boolean,
  interval: String,
};

const PaymentMethodTabs = (props: Props) => {
  const { tabs, tabPanels, onSelect, defaultSelectedTab, name, paymentTypes, tabName, mode, upiDown, applePayment,isApplePay,interval } = props;
  const [selectedIndex, setSelectedIndex] = useState(defaultSelectedTab || 0);

  
  const localOnSelect = data => {
    setSelectedIndex(data);
    localStorage.setItem(`${name}-tap-index`, data);
    if (onSelect) { onSelect(data); }
  };

  return (
    <FlexContainer
      className="pt-3 pt-lg-5 w-100"
      box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
      display="flow-root"
    >
      <H1Text
        className="px-1 px-md-4"
        marginBottom="30px"
      >
        {mode === 'Transfer' ? 'PROVIDE BANK ACCOUNT' : 'SELECT PAYMENT METHOD'}
        
      </H1Text>
      <Tabs className="tab" onSelect={localOnSelect} selectedIndex={selectedIndex} selectedTabClassName="text-primary tab-active">
        <TabList className="px-1 px-md-4 row">
          {tabs && tabs.map((value, index) => (
            <Tab key={index} disabled={(upiDown && value.name === "UPI") ? upiDown : value.disabled}
              className={value.name === "UPI / QR"
                ? "col-6 col-sm-3 col-md-4 text-center"
                : value.name === "INSTANT PAYMENT"
                  ? "col-6 col-sm-3 col-md-4 text-center"
                  : "col-6 col-sm-3 col-md-3 text-center"}
              style={{ outline: "none", cursor: (upiDown && value.name === "UPI") ? "no-drop" :  (value.disabled ? "no-drop" : "pointer") }}>
              {value.disabled && selectedIndex === index && setSelectedIndex(0)}
              <Col className="tab-menu-content">
                <div style={{ height: "30px", cursor: (upiDown && value.name === "UPI") ? "no-drop !important" : (value.disabled ? "no-drop !important" : "pointer !important") }}>
                  {value.icon}
                </div>
                <Text className="tab-menu-content-text text-center" color="inherit" fontWeight="600" style={{ outline: "none", cursor: (upiDown && value.name === "UPI") ? "no-drop" : (value.disabled ? "no-drop" : "pointer") }} paddingBottom="3px">{value.name}</Text>
              </Col>
            </Tab>
          ))}
   {(interval === "ONETIME" || !interval) && applePayment && isApplePay ? (
    <Tab>
  <Col className="tab-menu-content">
    <div style={{ height: "30px", cursor: "pointer" }}>
      <ApplePayLogo />
</div>
    <Text 
      className="tab-menu-content-text text-center" 
      color="inherit" 
      fontWeight="600" 
      style={{ outline: "none", cursor: "pointer" }} 
      paddingBottom="3px"
    >
      {'\u200B'} {/* Zero-width space */}
    </Text>
  </Col>
</Tab>
) :  
null
}

            
        </TabList>
        {(mode === 'Transfer') && (paymentTypes === 'US') ? (
          <Text className="px-1 px-md-4" paddingTop="8px" paddingBottom="8px">Please provide a valid bank account in United States or Canada to receive funds.</Text>
        ) : (mode === 'Transfer') && (paymentTypes === 'IN') ? (
          <Text className="px-1 px-md-4" paddingTop="8px" paddingBottom="8px">Please provide a valid bank account in India to receive funds.</Text>
        ) : (tabName === 'ACH') ? (
          <Text className="px-1 px-md-4" paddingTop="8px" paddingBottom="8px">Please provide a valid bank account in United States or Canada.</Text>
        ) : (tabName === 'NET_BANKING') ? (
          <Text className="px-1 px-md-4" paddingTop="8px" paddingBottom="8px">Choose from a complete range of national and international banks.</Text>
        ) : (tabName === 'INSTANT_PAYMENT') ? (
          <Text className="px-1 px-md-4" paddingTop="8px" paddingBottom="8px">Use your Swirepay Wallet</Text>
        ) : (tabName === 'SWIREPAY_US') ? (
          <Text className="px-1 px-md-4" paddingTop="8px" paddingBottom="8px">Use your Swirepay Wallet</Text>
        ) : (
          <>
            {
              tabName === 'UPI' ? (
                <Text className="px-1 px-md-4" paddingTop="8px" paddingBottom="8px" style={{ lineHeight: '20px' }}>Choose from Google Pay, Paytm, Amazon Pay and other digital wallets.</Text>
              ) : (
                <Text className="px-1 px-md-4" paddingTop="8px" paddingBottom="8px">
                  {paymentTypes === 'IN'
                    ? 'Choose from Visa, Mastercard, RuPay, and more'
                    : 'Choose from Visa, Mastercard, Amex, and more'
                  }
                </Text>
              )
            }

          </>
        )}
        <Hr width="100%" marginTop="15px" borderTop="1px solid rgba(0, 0, 0, 0.1)" />
        {tabPanels && tabPanels.map((value, index) => (
          <TabPanel key={index}>
            <div className="mt-4">
              {value.children}
            </div>
          </TabPanel>
        ))}
      </Tabs>
    </FlexContainer>
  )
};

export default PaymentMethodTabs;
